//Bills path
export const BILL_PATHS = {
  PAY_BILLS: "/paybills",
  BILLS: "/bills",
  BULK_UPLOAD_BILLS: "/bills/bulk",
  PAYMENT_RUN_PREVIEW: "/bills/payment-run/pay/:billIDs",
  PAYMENT_RUN: "/bills/payment-run",
};
